import profile from './pages/profile/store'

export default {
  namespaced: true,
  modules: {
    profile,
  },
}
